// extracted by mini-css-extract-plugin
export default {"CardStack":"CardStackWithThemeCard_CardStack__ZWE3M","CardStackWithThemeCard":"CardStackWithThemeCard_CardStackWithThemeCard__ODRiN","card":"CardStackWithThemeCard_card__MGMzZ"};